import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { User } from 'anchor-shared/lib/model/entity/user';
import { UserDAO } from '../../../core/services/dao/userDAO';
import { Subject } from 'rxjs';
import { NgForm } from '@angular/forms';
import * as moment from 'moment';
import * as intlTelInput from 'intl-tel-input';

@Component({
  selector: 'app-sign-up-form',
  templateUrl: './sign-up-form.component.html',
  styleUrls: ['./sign-up-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SignUpFormComponent implements OnInit, AfterViewInit {
  @ViewChild('intlTelInput') private _inputElement!: ElementRef;
  private _intlTelInput: any;
  public E164PhoneNumber!: string | null;
  @Output() onEnrollementFailed = new EventEmitter<boolean>();
  @Output() onEnrolled = new EventEmitter<any>();

  public model: any = {};
  @ViewChild('signUpForm') public signUpForm: NgForm;
  public startDate: any;
  public maxDate: any;

  public toVerifyEmail: Subject<string> = new Subject<string>();

  constructor(private userDAO: UserDAO) {
    this.startDate = moment().subtract(18, 'years');
    this.maxDate = moment().subtract(18, 'years');
    this.maxDate.add(1, 'days');
  }

  public enroll() {
    this.model.username = this.model.email;
    this.model.phoneNumber = this.E164PhoneNumber;
    this.userDAO.enrollUser(this.model).subscribe(
      (data: User) => {
        data.password = this.model.password;
        this.onEnrolled.emit(data);
      },
      () => {
        this.onEnrollementFailed.emit(false);
      },
    );
  }

  public emailBlurred(emailString: string) {
    this.toVerifyEmail.next(emailString); //add to subject string, verification handled through [enrollEmailDuplicate] directive
  }

  public emailKeyupHandler(emailString: string) {
    this.toVerifyEmail.next(emailString); //add to subject string, verification handled through [enrollEmailDuplicate] directive
  }

  ngAfterViewInit(): void {
    const intlTelInputInstance = intlTelInput;
    setTimeout(() => {
      this._intlTelInput = intlTelInputInstance(
        this._inputElement.nativeElement,
        { preferredCountries: ['us', 'mx'] },
      );
    }, 1000);
  }

  get intlTelInput(): any {
    return this._intlTelInput;
  }

  get internationalPhoneNumber(): string {
    return this.model.phoneNumber;
  }

  set internationalPhoneNumber(value: string) {
    if (!!value) {
      this._intlTelInput.setNumber(value);
    }
    this.model.phoneNumber = value;
    this.i18nizePhoneNumber();
  }

  public i18nizePhoneNumber(): void {
    this.E164PhoneNumber = null;
    if (this._intlTelInput.isValidNumber()) {
      this.E164PhoneNumber = this._intlTelInput.getNumber();
    }
  }

  hasInvalidPhoneNumber(): boolean {
    if (this._intlTelInput && this._intlTelInput.isValidNumber()) {
      return false;
    }
    return true;
  }

  ngOnInit() {}
}
